import { Contact } from "./contact";
import { ProjectRole, ValidityStatus } from "./enums";
import { Organisation } from "./organisation";
import { TopicOfInterest } from "./topic-of-interest";

export class Project {
    id!: number;
    name!: string; // was shortName but it's easier to use name so that it's compatible with ChipSelect component
    fullName?: string | null;
    startDate?: string | null; // ISO date string (e.g., '2025-09-29')
    endDate?: string | null;
    website?: string;
    euficRole!: ProjectRole;
    topics: TopicOfInterest[] = [];
    addedBy?: string;
    events: Event[] = [];
    contacts: Contact[] = [];
    organisations: Organisation[] = [];

    lastModifiedBy?: string | null;
    lastModifiedOn?: string | null;

    constructor(init?: Partial<Project>) {
        Object.assign(this, init);
    }

    validityStatus(): ValidityStatus {
        if (!(this.name && this.euficRole && ((this.topics?.length ?? 0) > 0))) {
            return ValidityStatus.INVALID;
        } else if (!(this.startDate && this.endDate)) {
            return ValidityStatus.INCOMPLETE;
        } else {
            return ValidityStatus.VALID;
        }
    }
}
